import autoSizeFromParentBoundsFactory from 'components/auto-size-from-parent-bounds';
import TableItem from './table-item';

import TableItemCellRenderer from './table-item-cell-renderer';
import TableTotalCellRenderer from './table-total-cell-renderer';

const TableItemWithAutoSize = autoSizeFromParentBoundsFactory(TableItem);

export default TableItemWithAutoSize;
export {
  TableItemWithAutoSize as TableItem,
  TableItemCellRenderer,
  TableTotalCellRenderer,
};
